// 华凯
import { StyledPropsTheme } from '../../types';
import parent from './standard';

export default Object.assign({}, parent, {
	COLOR_PRIMARY: '#ED4D58', // 标准色
	COLOR_PRIMARY_LIGHT_O75: 'rgba(237, 77, 88, 0.75)', // 标准色75%透明
	COLOR_PRIMARY_LIGHT_010: 'rgba(237, 77, 88, 0.1)',
	COLOR_PRIMARY_LIGHT: '#f27b83', // 标准色淡10%
	INPUT_FOCUS_BORDER_COLOR: 'rgba(237, 77, 88, 0.8)', // 输入框获取焦点后边框色
	TOGGLE_TRUE_BORDER_COLOR: '#ED4D58',
	TOGGLE_TRUE_BACKGROUND_COLOR: '#ED4D58'
}) as StyledPropsTheme;

